// Chính sách mật khẩu: ≥8 ký tự, có chữ HOA, có SỐ, có ký tự đặc biệt.
export function passwordError(pwd) {
  const p = String(pwd || '');
  if (p.length < 8) return 'Cần ít nhất 8 ký tự';
  if (!/[A-Z]/.test(p)) return 'Cần có chữ in hoa';
  if (!/[0-9]/.test(p)) return 'Cần có chữ số';
  if (!/[^A-Za-z0-9]/.test(p)) return 'Cần có ký tự đặc biệt (@ # $ …)';
  return null;
}

export const PASSWORD_HINT = 'Tối thiểu 8 ký tự, gồm chữ in hoa, chữ số và ký tự đặc biệt (@ # $ …).';

// Các tiêu chí để hiển thị checklist (✓/✗).
export function passwordChecks(pwd) {
  const p = String(pwd || '');
  return [
    { ok: p.length >= 8, label: '≥ 8 ký tự' },
    { ok: /[A-Z]/.test(p), label: 'Chữ in hoa' },
    { ok: /[0-9]/.test(p), label: 'Chữ số' },
    { ok: /[^A-Za-z0-9]/.test(p), label: 'Ký tự đặc biệt' },
  ];
}
